export default function Hero() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-screen flex items-center overflow-hidden"
    >
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Dark%20cinematic%20atmosphere%20with%20warm%20deep%20red%20and%20gold%20gradient%20lighting%2C%20abstract%20film%20reel%20texture%20overlay%2C%20theater%20curtain%20folds%20in%20rich%20crimson%20tones%2C%20dramatic%20spotlight%20effect%20from%20top%20left%2C%20luxurious%20dark%20background%20with%20subtle%20bokeh%2C%20elegant%20cinematic%20mood%2C%20no%20text%20or%20faces%2C%20artistic%20film%20noir%20inspired%20composition&width=1920&height=1080&seq=hero-bg-momo-2026&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/60"></div>

      <div className="relative w-full px-4 md:px-6 py-24 md:py-32">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-500/20 backdrop-blur-sm border border-accent-400/30 text-accent-200 text-sm font-medium mb-6">
              <i className="ri-fire-line mr-1.5"></i>每日更新 · 高清画质 · 极速播放
            </span>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight mb-4">
              陌陌影视
              <span className="block text-xl md:text-2xl lg:text-3xl font-normal text-white/80 mt-2">
                你的在线电影大全
              </span>
            </h1>

            <p className="text-lg md:text-xl text-white/60 font-light mb-2">
              最新热映、经典老片、排行榜单，一站式免费观影平台
            </p>

            <p className="text-sm md:text-base text-white/50 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              陌陌影视汇聚海量电影资源，覆盖动作、喜剧、爱情、科幻、悬疑等全类型片库。
              每日精选更新，确保你不错过任何一部热映大片。高清画质搭配极速加载引擎，
              无论是周末宅家还是通勤路上，打开陌陌影视即可畅享影院级观影体验。
              本周主打<strong className="text-white/80">暑期档特辑</strong>，多部院线热片同步上线。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">10,000+</div>
                <div className="text-xs text-white/50 mt-1">影片资源</div>
              </div>
              <div className="w-px h-10 bg-white/15"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">每日 50+</div>
                <div className="text-xs text-white/50 mt-1">片源更新</div>
              </div>
              <div className="w-px h-10 bg-white/15"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">1080P</div>
                <div className="text-xs text-white/50 mt-1">高清全覆盖</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <button
                onClick={() => scrollTo('#media')}
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-lg text-sm whitespace-nowrap cursor-pointer transition-all duration-200"
              >
                <i className="ri-play-circle-line mr-2"></i>开始观影
              </button>
              <button
                onClick={() => scrollTo('#ranking')}
                className="w-full sm:w-auto px-8 py-3.5 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white border border-white/25 rounded-lg text-sm font-medium whitespace-nowrap cursor-pointer transition-all duration-200"
              >
                <i className="ri-medal-line mr-2"></i>查看榜单
              </button>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-[280px] h-[380px] md:w-[340px] md:h-[440px] lg:w-[380px] lg:h-[480px] rounded-2xl overflow-hidden border border-white/10">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20collage%20poster%20with%20layered%20film%20elements%2C%20vintage%20film%20reel%20and%20projector%20silhouette%2C%20warm%20golden%20and%20deep%20red%20color%20palette%2C%20dramatic%20theater%20spotlight%20effect%2C%20artistic%20double%20exposure%20of%20cinema%20hall%20and%20film%20strip%2C%20luxurious%20velvet%20curtain%20texture%20at%20edges%2C%20elegant%20film%20noir%20atmosphere%2C%20rich%20dark%20background%20with%20subtle%20grain%2C%20no%20visible%20text%20or%20human%20faces&width=760&height=960&seq=hero-visual-momo&orientation=portrait"
                alt="陌陌影视 — 电影主题视觉"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}